import React from "react";
import cx from "classnames";
import { ReactComponent as ChevronRight } from "../../../../../images/svg/icons/chevron-right.svg";
import { IconTextLink } from "../../../../Atoms/IconTextLink/IconTextLink";

interface Props {
  label: string;
  linkUrl: string;
}

const QuickActionButton = ({ label, linkUrl }: Props) => {
  return (
    <IconTextLink
      variant="button-icon-text"
      renderLabel={
        <div className="flex">
          {label} <ChevronRight height={25} />
        </div>
      }
      linkUrl={linkUrl}
      className={cx(
        "h-10 w-[154px] hidden md:flex flex-shrink-0 border-none",
        "font-secondary font-medium text-color-neutral-one uppercase",
        "hover:text-white hover:bg-color-brand-two"
      )}
    />
  );
};

export default QuickActionButton;
